/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PlaylistAddedTimestamp } from './PlaylistAddedTimestamp';
import {
    PlaylistAddedTimestampFromJSON,
    PlaylistAddedTimestampFromJSONTyped,
    PlaylistAddedTimestampToJSON,
} from './PlaylistAddedTimestamp';
import type { PlaylistArtwork } from './PlaylistArtwork';
import {
    PlaylistArtworkFromJSON,
    PlaylistArtworkFromJSONTyped,
    PlaylistArtworkToJSON,
} from './PlaylistArtwork';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface Playlist
 */
export interface Playlist {
    /**
     * 
     * @type {PlaylistArtwork}
     * @memberof Playlist
     */
    artwork?: PlaylistArtwork;
    /**
     * 
     * @type {string}
     * @memberof Playlist
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Playlist
     */
    permalink?: string;
    /**
     * 
     * @type {string}
     * @memberof Playlist
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof Playlist
     */
    isAlbum: boolean;
    /**
     * 
     * @type {string}
     * @memberof Playlist
     */
    playlistName: string;
    /**
     * 
     * @type {Array<PlaylistAddedTimestamp>}
     * @memberof Playlist
     */
    playlistContents: Array<PlaylistAddedTimestamp>;
    /**
     * 
     * @type {number}
     * @memberof Playlist
     */
    repostCount: number;
    /**
     * 
     * @type {number}
     * @memberof Playlist
     */
    favoriteCount: number;
    /**
     * 
     * @type {number}
     * @memberof Playlist
     */
    totalPlayCount: number;
    /**
     * 
     * @type {User}
     * @memberof Playlist
     */
    user: User;
    /**
     * 
     * @type {string}
     * @memberof Playlist
     */
    coverArtSizes?: string;
}

/**
 * Check if a given object implements the Playlist interface.
 */
export function instanceOfPlaylist(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "isAlbum" in value;
    isInstance = isInstance && "playlistName" in value;
    isInstance = isInstance && "playlistContents" in value;
    isInstance = isInstance && "repostCount" in value;
    isInstance = isInstance && "favoriteCount" in value;
    isInstance = isInstance && "totalPlayCount" in value;
    isInstance = isInstance && "user" in value;

    return isInstance;
}

export function PlaylistFromJSON(json: any): Playlist {
    return PlaylistFromJSONTyped(json, false);
}

export function PlaylistFromJSONTyped(json: any, ignoreDiscriminator: boolean): Playlist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'artwork': !exists(json, 'artwork') ? undefined : PlaylistArtworkFromJSON(json['artwork']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'permalink': !exists(json, 'permalink') ? undefined : json['permalink'],
        'id': json['id'],
        'isAlbum': json['is_album'],
        'playlistName': json['playlist_name'],
        'playlistContents': ((json['playlist_contents'] as Array<any>).map(PlaylistAddedTimestampFromJSON)),
        'repostCount': json['repost_count'],
        'favoriteCount': json['favorite_count'],
        'totalPlayCount': json['total_play_count'],
        'user': UserFromJSON(json['user']),
        'coverArtSizes': !exists(json, 'cover_art_sizes') ? undefined : json['cover_art_sizes'],
    };
}

export function PlaylistToJSON(value?: Playlist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'artwork': PlaylistArtworkToJSON(value.artwork),
        'description': value.description,
        'permalink': value.permalink,
        'id': value.id,
        'is_album': value.isAlbum,
        'playlist_name': value.playlistName,
        'playlist_contents': ((value.playlistContents as Array<any>).map(PlaylistAddedTimestampToJSON)),
        'repost_count': value.repostCount,
        'favorite_count': value.favoriteCount,
        'total_play_count': value.totalPlayCount,
        'user': UserToJSON(value.user),
        'cover_art_sizes': value.coverArtSizes,
    };
}

